import { Club } from '../types';
import clubsData from './clubs.json';

export const getGoogleMapsLink = (club: Club) => {
    if (club.mapsUrl) return club.mapsUrl;
    // Build a more specific query with address if available
    const parts = [club.name, club.address, club.city, 'padel'].filter(Boolean);
    const query = parts.join(' ');
    return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(query)}`;
};



export const STATIC_CLUBS_SEED_DATA: Partial<Club>[] = clubsData as unknown as Partial<Club>[];
